import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface PageTab {
  label: string;
  path: string;
}

interface PageTabBarProps {
  tabs: PageTab[];
}

const PageTabBar: React.FC<PageTabBarProps> = ({ tabs }) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="flex overflow-x-auto shrink-0 px-4 border-b border-fp-border no-scrollbar">
      {tabs.map(tab => {
        const isActive = location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            type="button"
            onClick={() => navigate(tab.path)}
            className={`px-3.5 py-1.5 text-[13px] whitespace-nowrap shrink-0 bg-transparent border-0 -mb-px border-b-2 border-solid transition-colors duration-[120ms] ${
              isActive
                ? 'font-semibold text-blue-300 border-blue-500 cursor-default'
                : 'font-normal text-slate-500 border-transparent cursor-pointer hover:text-slate-400'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default PageTabBar;
